// extracted by mini-css-extract-plugin
module.exports = {"container":"Address_container__2S2NX","card":"Address_card__2JZ4e","newBtn":"Address_newBtn__niR3m","btnContainer":"Address_btnContainer__mbNTW"};